import React from 'react'
import { useTranslation } from 'react-i18next'
import { AppStatus } from 'components/layout/AppStatus'

export const ApplicationUnsuccessful = () => {
  const { t } = useTranslation()

  return (
    <AppStatus animationName="no-results" title={t('applicationUnsuccessful.title')}>
      <p>{t('applicationUnsuccessful.notOffered')}</p>
    </AppStatus>
  )
}
